/**
 * Helpers for the editable homepage copy stored in D1 — Asana O2-47.
 */

/**
 * Drops a leading <h1> from managed page copy.
 *
 * The homepage title and dates are rendered by Blocks/rich-text.vue now rather
 * than typed into /admin, because the editor could only approximate them with
 * inline styles and could not reach the condensed display face the rest of the
 * page uses. The copy currently in D1 still opens with its own hand-built
 * heading, so without this the page would show the title and dates twice until
 * someone edited it out — and it would come back the moment anyone pasted a
 * heading in again.
 *
 * Deliberately only the FIRST element, and only when the content opens with it:
 * headings further down are the editor's own section headings and are left
 * alone. <h1> cannot nest, so a non-greedy match to the first closing tag is
 * exact rather than a guess.
 */
export function stripLeadingH1(html: unknown): string {
    if (typeof html !== 'string') return '';
    return html.replace(/^\s*<h1\b[^>]*>[\s\S]*?<\/h1>\s*/i, '');
}
